export const insertSubdomain = (originalDomain, subDomain, path = '') => {
  const http = originalDomain.match(/^(?:https?:\/\/)?(?:www\.)?/)[0];
  const domain = originalDomain.replace(http, '');
  const lastChar = originalDomain.substr(-1);

  return lastChar === '/' ? `${http}${subDomain}.${domain}${path}` : `${http}${subDomain}.${domain}/${path}`;
};
